import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { useGetAccountsQuery } from "../../store/api";
import { AccountTableList } from "./account-list/table";

export const AccountsList = () => {

  const accountInformation = useAppSelector(({ account }: RootState) => account);

  const { data: accountsFounded = [], error: errorGetRaffles } = useGetAccountsQuery(undefined, {
    skip: accountInformation.id !== 'vip-rifas'
  });


  const totalAccounts = accountsFounded.length;

  const ownerAccounts = accountsFounded.filter(account => account.owner).length;

  return (
    <Grid container spacing={2} sx={{ background: '#000', p: 2 }}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}>
            <Typography variant="h6">Total Clientes</Typography>
            <Typography variant="h4" fontWeight="bold">{totalAccounts}</Typography>
          </Grid>

        
          <Grid item xs={12} sm={1}>
            <Typography variant="h6">Dueños</Typography>
            <Typography variant="h4" fontWeight="bold">{ownerAccounts}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} xl={12} md={12}>
          <AccountTableList accounts={accountsFounded} />
      </Grid>
    </Grid>
  );
};
